import React from 'react';
import { Outlet, useLocation, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext'; // Keep this import
import { Phone, MessageSquare, Facebook, Gift } from 'lucide-react';
import Navbar from './Navbar';
import AIChatbot from './AIChatbot';

export default function Layout() {
  const location = useLocation();
  const { user } = useAuth();
  const isRegistryPage = location.pathname.startsWith('/registries/');
  const isGuestView = isRegistryPage && !user;

  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-br from-luxury-navy-900 via-primary-900 to-luxury-navy-800 relative">
      <div className="absolute inset-0 bg-mesh opacity-10"></div>
      {!isGuestView && <Navbar />}
      <main className="flex-1 container-luxury py-8 mt-16 relative z-10">
        <Outlet />
      </main>
      {user && <AIChatbot />}
      <footer className="relative mt-auto py-12 bg-black/20 backdrop-blur-xl border-t border-white/10 z-10">
        <div className="container-luxury">
          <div className="flex flex-col items-center space-y-6">
            <div className="flex items-center">
              <img src="/white-no-logo.png" alt="Giftyfy" className="h-20" style={{ mixBlendMode: 'screen' }} />
            </div>
            <p className="text-white/60 font-body">
              Making gift-giving delightful and memorable
            </p>
            <div className="flex flex-col sm:flex-row items-center gap-6">
              <a 
                href="tel:+94779257975" 
                className="relative z-20 inline-flex items-center px-6 py-3 rounded-xl glass-effect hover:bg-white/10 transition-all duration-300 text-white/80 hover:text-white cursor-pointer font-body"
              >
                <Phone className="w-4 h-4 mr-2" />
                <span>+94 779257975</span>
              </a>
              <a 
                href="https://wa.me/94779257975" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="relative z-20 inline-flex items-center px-6 py-3 rounded-xl glass-effect hover:bg-white/10 transition-all duration-300 text-white/80 hover:text-white cursor-pointer font-body"
              >
                <MessageSquare className="w-4 h-4 mr-2" />
                <span>WhatsApp</span>
              </a>
              <a 
                href="https://web.facebook.com/GiftyfyOfficial" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="relative z-20 inline-flex items-center px-6 py-3 rounded-xl glass-effect hover:bg-white/10 transition-all duration-300 text-white/80 hover:text-white cursor-pointer font-body"
              >
                <Facebook className="w-4 h-4 mr-2" />
                <span>Facebook</span>
              </a>
            </div>
            <div className="flex items-center space-x-6 text-sm text-white/40 font-body">
              <Link to="/privacy-policy" className="hover:text-white transition-colors">
                Privacy Policy
              </Link>
              <Link to="/refund-policy" className="hover:text-white transition-colors">
                Refund Policy
              </Link>
              <Link to="/terms-conditions" className="hover:text-white transition-colors">
                Terms & Conditions
              </Link>
            </div>
            <p className="text-sm text-white/40 font-body">
              © {new Date().getFullYear()} Giftyfy. All rights reserved.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}